import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { breakpoint, size } from '@twistopayments/design-system/styles'

export const container = (theme: Theme) => css`
  display: grid;
  position: relative;
  width: 100%;
  align-items: center;
  padding: ${size[12]};
  margin: ${size[32]} auto;
  color: ${theme.palette.tertiary.upperMediumContrast};
  background: ${theme.palette.tertiary.lowContrast};
  border-radius: ${theme.borderRadius.md};
  overflow: hidden;

  table {
    display: block;
    overflow-y: auto;
  }

  & > div {
    max-width: 100%;
    overflow: hidden;
  }

  ${breakpoint.up('sm')} {
    padding: ${size[16]};
  }
`

export const iconButton = css`
  position: absolute;
  bottom: ${size[16]};
  left: ${size[16]};
`
